import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';
import Context from '@bibliocommons/context';

import { selectFeatureStatuses } from 'app/selectors/FeatureTogglzSelector';
import { selectAppConfig } from 'app/selectors/AppSelector';
import { selectLocalization } from 'app/selectors/LocalizationSelector';
import { ErrorBoundaryContainer } from 'app/components/errors/ErrorBoundary';

function mapStateToProps(state) {
  const appConfig = selectAppConfig(state);
  return {
    localization: selectLocalization(state),
    coreCdnHost: appConfig.getIn(['coreAssets', 'cdnHost']),
    mobileApp: appConfig.get('mobileApp', false),
    baseURL: appConfig.get('baseURL'),
    features: selectFeatureStatuses(state)
  };
}

class ApplicationContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    const { currentLanguage } = props.localization;
    const locale = currentLanguage === 'fil-PH' ? 'tl-PH' : currentLanguage;
    moment.locale(locale);
    this.state = {
      hydrated: false,
      backToLinkEnabled: false
    };
  }

  componentDidMount() {
    this.setState({ hydrated: true });
  }

  render() {
    const { children, localization, messages = {} } = this.props;
    const contextValue = {
      baseURL: this.props.baseURL,
      coreCdnHost: this.props.coreCdnHost,
      mobileApp: this.props.mobileApp,
      features: this.props.features,
      hydrated: this.state.hydrated,
      backToLinkEnabled: this.state.backToLinkEnabled,
      setBackToLinkEnabled: backToLinkEnabled => this.setState({ backToLinkEnabled })
    };

    return (
      <ErrorBoundaryContainer>
        <IntlProvider
          timeZone="UTC"
          messages={{ ...localization.messages, ...messages }}
          locale={localization.currentLanguage}
          defaultLocale={localization.currentLanguage}
        >
          <Context.Provider value={contextValue}>{children}</Context.Provider>
        </IntlProvider>
      </ErrorBoundaryContainer>
    );
  }
}

ApplicationContainer.propTypes = {
  baseURL: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  coreCdnHost: PropTypes.string.isRequired,
  features: ImmutablePropTypes.mapOf(PropTypes.bool, PropTypes.oneOf(Object.values(TOGGLZ_FEATURES))).isRequired,
  localization: PropTypes.shape({
    messages: PropTypes.objectOf(PropTypes.string),
    currentLanguage: PropTypes.string
  }).isRequired,
  messages: PropTypes.objectOf(PropTypes.string),
  mobileApp: PropTypes.bool.isRequired
};

export default connect(mapStateToProps)(ApplicationContainer);
